import 'angular';

import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';

import { VehicleRegistrationLookupsComponent } from './vehicle-registration.lookups.component';
import { VehicleRegistrationService }          from './vehicle-registration.service';
import { VehicleRegistrationStatusComponent }  from './vehicle-registration.status.component';

angular.module('app-lite.vehicle-registrations', [])
  .directive('vehicleRegistrationLookups', downgradeComponent({ component: VehicleRegistrationLookupsComponent }) as ng.IDirectiveFactory)
  .directive('vehicleRegistrationStatus', downgradeComponent({ component: VehicleRegistrationStatusComponent }) as ng.IDirectiveFactory)
  .service('vehicleRegistrationApi', downgradeInjectable(VehicleRegistrationService));
